import { render, staticRenderFns } from "./CaptionJoinrealtime.vue?vue&type=template&id=2864aed6&scoped=true&"
import script from "./CaptionJoinrealtime.vue?vue&type=script&lang=js&"
export * from "./CaptionJoinrealtime.vue?vue&type=script&lang=js&"
import style0 from "./CaptionJoinrealtime.vue?vue&type=style&index=0&id=2864aed6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2864aed6",
  null
  
)

export default component.exports